import React from "react";
import { getCurrentUserFromLocalStorage, monthConverter } from "utils/common";

const TableComponent = ({
  reportsData,
  currentLevel,
  reportInfo,
  tableRef,
}) => {
  const currentUser = getCurrentUserFromLocalStorage();
  const isRs = currentUser?.fasyankes_type_id === "jnsfas-02";

  const calculateTotal = () => {
    return reportsData.reduce(
      (total, item) => {
        // positif mikroskop
        total.r1_m_pcd += parseInt(item.r1_m_pcd ?? 0);
        total.r1_m_survmigrasi += parseInt(item.r1_m_survmigrasi ?? 0);
        // positif RDT
        total.r1_r_pcd += parseInt(item.r1_r_pcd ?? 0);
        total.r1_r_survmigrasi += parseInt(item.r1_r_survmigrasi ?? 0);
        // negatif mikroskop
        total.r2_m_pcd += parseInt(item.r2_m_pcd ?? 0);
        total.r2_m_survmigrasi += parseInt(item.r2_m_survmigrasi ?? 0);
        // negatif RDT
        total.r2_r_pcd += parseInt(item.r2_r_pcd ?? 0);
        total.r2_r_survmigrasi += parseInt(item.r2_r_survmigrasi ?? 0);
        // mikroskop (positif + negatif)
        total.total_m_pcd +=
          parseInt(item.r1_m_pcd ?? 0) + parseInt(item.r2_m_pcd ?? 0);
        total.total_m_survmigrasi +=
          parseInt(item.r1_m_survmigrasi ?? 0) +
          parseInt(item.r2_m_survmigrasi ?? 0);
        // RDT (positif + negatif)
        total.total_r_pcd +=
          parseInt(item.r1_r_pcd ?? 0) + parseInt(item.r2_r_pcd ?? 0);
        total.total_r_survmigrasi +=
          parseInt(item.r1_r_survmigrasi ?? 0) +
          parseInt(item.r2_r_survmigrasi ?? 0);
        // TOTAL (positif + negatif)
        total.total_pcd +=
          parseInt(item.r1_m_pcd ?? 0) +
          parseInt(item.r1_r_pcd ?? 0) +
          parseInt(item?.r2_m_pcd ?? 0) +
          parseInt(item?.r2_r_pcd ?? 0);
        total.total_survmigrasi +=
          parseInt(item?.r1_m_survmigrasi ?? 0) +
          parseInt(item.r1_r_survmigrasi ?? 0) +
          parseInt(item?.r2_m_survmigrasi ?? 0) +
          parseInt(item?.r2_r_survmigrasi ?? 0);

        total.total_suspect = total.total_m_pcd + total.total_m_survmigrasi;

        return total;
      },
      {
        // positif mikroskop
        r1_m_pcd: 0,
        r1_m_survmigrasi: 0,
        // positif RDT
        r1_r_pcd: 0,
        r1_r_survmigrasi: 0,
        // negatif mikroskop
        r2_m_pcd: 0,
        r2_m_survmigrasi: 0,
        // negatif RDT
        r2_r_pcd: 0,
        r2_r_survmigrasi: 0,
        // mikroskop (positif + negatif)
        total_m_pcd: 0,
        total_m_survmigrasi: 0,
        // RDT (positif + negatif)
        total_r_pcd: 0,
        total_r_survmigrasi: 0,
        // TOTAL (positif + negatif)
        total_pcd: 0,
        total_survmigrasi: 0,

        total_suspect: 0,
      }
    );
  };

  const total = calculateTotal();

  let levelName = "";
  if (currentLevel === "nasional") {
    levelName = "Nasional";
  } else if (currentLevel === "induk") {
    levelName = "BKK Induk";
  } else {
    levelName = "BKK Wilker";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.wilker;
  let parts = data?.split(",");
  let bkkWilkerName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = bkkWilkerName?.join(", ");

  return (
    <div
      className="table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none" }}>
            <h3>SISMAL v3, REGMAL 2 BKK</h3>
          </th>
        </tr>
      </table>
      <table>
        <thead>
          <tr style={{ border: "none" }}>
            <th
              width="200"
              style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
            >
              Periode Laporan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {periodeName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Tahun
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.periode?.year}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} -{" "}
              {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              BKK Induk
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.induk
                ? "Semua BKK Induk"
                : reportInfo?.induk?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>BKK Wilker</th>
            <th style={{ border: "none", paddingTop: 0 }}>
              : {!reportInfo?.wilker ? "Semua BKK Wilker" : result}
            </th>
          </tr>
        </thead>
      </table>
      <table>
        <thead>
          <tr>
            <th rowSpan={2}>No.</th>
            {currentLevel === "nasional" && (
              <>
                <th rowSpan={2}>Provinsi</th>
                <th rowSpan={2}>Kabupaten</th>
                <th rowSpan={2}>BKK Induk</th>
                <th rowSpan={2}>BKK Wilker</th>
              </>
            )}
            {currentLevel !== "nasional" && <th rowSpan={2}>Wilayah</th>}
            <th colSpan={2}>Positif Mikroskop</th>
            <th colSpan={2}>Positif RDT</th>
            <th colSpan={2}>Negatif Mikroskop</th>
            <th colSpan={2}>Negatif RDT</th>
            <th colSpan={2}>Mikroskop (Positif + Negatif)</th>
            <th colSpan={2}>RDT (Positif + Negatif)</th>
            <th colSpan={2}>TOTAL (Positif + Negatif)</th>
          </tr>
          <tr>
            {/* positif mikroskop */}
            <th>PCD</th>
            <th>Surveilans Migrasi</th>
            {/* Positif RDT */}
            <th>PCD</th>
            <th>Surveilans Migrasi</th>
            {/* negatif mikroskop */}
            <th>PCD</th>
            <th>Surveilans Migrasi</th>
            {/* negatif RDT */}
            <th>PCD</th>
            <th>Surveilans Migrasi</th>
            {/* Mikroskop (positif + negatif) */}
            <th>PCD</th>
            <th>Surveilans Migrasi</th>
            {/* RDT (Positif + Negatif) */}
            <th>PCD</th>
            <th>Surveilans Migrasi</th>
            {/* TOTAL (Positif + Negatif) */}
            <th>PCD</th>
            <th>Surveilans Migrasi</th>
          </tr>
        </thead>
        <tbody>
          {reportsData ? (
            reportsData?.map((item, index) => (
              <tr key={item?.id}>
                <td>{index + 1}</td>
                {currentLevel === "nasional" && (
                  <>
                    <td>{item?.namaprop}</td>
                    <td>{item?.namakab}</td>
                    <td>{item?.nama_induk}</td>
                    <td>{item?.wilayah}</td>
                  </>
                )}
                {currentLevel !== "nasional" && <td>{item?.wilayah}</td>}
                {/* positif mikroskop */}
                <td>{item?.r1_m_pcd ?? 0}</td>
                <td>{item?.r1_m_survmigrasi ?? 0}</td>
                {/* positif RDT */}
                <td>{item?.r1_r_pcd ?? 0}</td>
                <td>{item?.r1_r_survmigrasi ?? 0}</td>
                {/* negatif mikroskop */}
                <td>{item?.r2_m_pcd ?? 0}</td>
                <td>{item?.r2_m_survmigrasi ?? 0}</td>
                {/* negatif rdt */}
                <td>{item?.r2_r_pcd ?? 0}</td>
                <td>{item?.r2_r_survmigrasi ?? 0}</td>
                {/* mikroskop (positif + negatif) */}
                <td>
                  {parseInt(item?.r1_m_pcd ?? 0) +
                    parseInt(item?.r2_m_pcd ?? 0)}
                </td>
                <td>
                  {parseInt(item?.r1_m_survmigrasi ?? 0) +
                    parseInt(item?.r2_m_survmigrasi ?? 0)}
                </td>
                {/* rdt (positif + negatif) */}
                <td>
                  {parseInt(item?.r1_r_pcd ?? 0) +
                    parseInt(item?.r2_r_pcd ?? 0)}
                </td>
                <td>
                  {parseInt(item?.r1_r_survmigrasi ?? 0) +
                    parseInt(item?.r2_r_survmigrasi ?? 0)}
                </td>
                {/* TOTAL (positif + negatif) */}
                <td>
                  {parseInt(item?.r1_m_pcd ?? 0) +
                    parseInt(item?.r1_r_pcd ?? 0) +
                    parseInt(item?.r2_m_pcd ?? 0) +
                    parseInt(item?.r2_r_pcd ?? 0)}
                </td>
                <td>
                  {parseInt(item?.r1_m_survmigrasi ?? 0) +
                    parseInt(item?.r1_r_survmigrasi ?? 0) +
                    parseInt(item?.r2_m_survmigrasi ?? 0) +
                    parseInt(item?.r2_r_survmigrasi ?? 0)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={17}>Tidak Ada Data</td>
            </tr>
          )}
          <tr style={{ backgroundColor: "#43766C" }}>
            {currentLevel === "nasional" ? (
              <td style={{ color: "#FFF" }} colSpan={5}>
                Total
              </td>
            ) : (
              <td style={{ color: "#FFF" }} colSpan={2}>
                Total
              </td>
            )}
            {/* positif mikroskop */}
            <td style={{ color: "#FFF" }}>{total.r1_m_pcd}</td>
            <td style={{ color: "#FFF" }}>{total.r1_m_survmigrasi}</td>
            {/* positif RDT */}
            <td style={{ color: "#FFF" }}>{total.r1_r_pcd}</td>
            <td style={{ color: "#FFF" }}>{total.r1_r_survmigrasi}</td>
            {/* negatif mikroskop */}
            <td style={{ color: "#FFF" }}>{total.r2_m_pcd}</td>
            <td style={{ color: "#FFF" }}>{total.r2_m_survmigrasi}</td>
            {/* negatif RDT */}
            <td style={{ color: "#FFF" }}>{total.r2_r_pcd}</td>
            <td style={{ color: "#FFF" }}>{total.r2_r_survmigrasi}</td>
            {/* mikroskop (positif + negatif) */}
            <td style={{ color: "#FFF" }}>{total.total_m_pcd}</td>
            <td style={{ color: "#FFF" }}>{total.total_m_survmigrasi}</td>
            {/* RDT (positif + negatif) */}
            <td style={{ color: "#FFF" }}>{total.total_r_pcd}</td>
            <td style={{ color: "#FFF" }}>{total.total_r_survmigrasi}</td>
            {/* TOTAL (positif + negatif) */}
            <td style={{ color: "#FFF" }}>{total.total_pcd}</td>
            <td style={{ color: "#FFF" }}>{total.total_survmigrasi}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
